<template>
  <v-flex xs12 sm10 md8 lg10>
    <v-card v-if="showAdressDetails">
      <v-container>
        <v-layout row wrap>
          <v-flex d-flex>
            <v-list two-line>
              <v-list-tile v-if="isAdmin" @click="openStatusForm">
                <v-list-tile-action>
                  <v-icon color="primary">folder</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ currentStatus }}</v-list-tile-title>
                  <v-list-tile-sub-title>Status</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-else>
                <v-list-tile-action>
                  <v-icon color="primary">folder</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ currentStatus }}</v-list-tile-title>
                  <v-list-tile-sub-title>Status</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openScheduleVisitForm">
                <v-list-tile-action>
                  <v-icon color="primary">calendar_today</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{ format(active.visitDate) }}</v-list-tile-title>
                  <v-list-tile-sub-title>Datum afspraak</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openScheduleVisitForm">
                <v-list-tile-action/>
                <v-list-tile-content>
                  <v-list-tile-title>{{
                      active.visitTime ? active.visitTime.substr(0, 5) : "onbekend"
                    }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>Tijdstip afspraak</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openPhoneDetailsForm">
                <v-list-tile-action>
                  <v-icon color="primary">phone</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{ formatPhoneNumber(active.phoneNumber1) }}</v-list-tile-title>
                  <v-list-tile-sub-title>Telefoonnummer</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-action/>
                <v-list-tile-content>
                  <v-list-tile-title>{{ formatPhoneNumber(active.phoneNumber2) }}</v-list-tile-title>
                  <v-list-tile-sub-title>Telefoonnummer</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile v-if="isAdmin" @click="openUpdateJobForm">
                <v-list-tile-action/>
                <v-list-tile-content>
                  <v-list-tile-title>{{ active.job || "onbekend" }}</v-list-tile-title>
                  <v-list-tile-sub-title>Uit te voeren werkzaamheden</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-else>
                <v-list-tile-action/>
                <v-list-tile-content>
                  <v-list-tile-title>{{ active.job || "onbekend" }}</v-list-tile-title>
                  <v-list-tile-sub-title>Uit te voeren werkzaamheden</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>
          <v-flex d-flex>
            <v-list two-line>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">home</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{ active.address.street }}</v-list-tile-title>
                  <v-list-tile-sub-title>Straatnaam</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-action/>
                <v-list-tile-content>
                  <v-list-tile-title>{{ active.address.homeNumber }}</v-list-tile-title>
                  <v-list-tile-sub-title>Huisnummer</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile v-if="active.address.addition">
                <v-list-tile-action/>
                <v-list-tile-content>
                  <v-list-tile-title>{{ active.address.addition }}</v-list-tile-title>
                  <v-list-tile-sub-title>Toevoeging</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-action/>
                <v-list-tile-content>
                  <v-list-tile-title>{{ active.address.postcode }}</v-list-tile-title>
                  <v-list-tile-sub-title>Postcode</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-action/>
                <v-list-tile-content>
                  <v-list-tile-title>{{ active.address.municipality }}</v-list-tile-title>
                  <v-list-tile-sub-title>Gemeente</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-action/>
                <v-list-tile-content>
                  <v-list-tile-title>{{ active.address.city }}</v-list-tile-title>
                  <v-list-tile-sub-title>Plaatsnaam</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

          </v-flex>

        </v-layout>
        <v-list two-line>
          <v-list-tile @click="openPlannerRemark">
            <v-list-tile-content>
              <v-list-tile-title v-if="active.remarkPlanner">
                <display-planner-remark :address="active"></display-planner-remark>
              </v-list-tile-title>
              <v-list-tile-title v-else>Nog niet gevuld</v-list-tile-title>
              <v-list-tile-sub-title>Planner opmerking</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            :class="[currentSurveyPlannerReady ? 'secundary' : 'primary']"
            to="/address/planner"
        >Plannen
        </v-btn>
        <v-btn
            :class="[currentSurveyMechanicReady ? 'secundary' : 'primary']"
            @click="openMechanicSurvey"
        >Monteren
        </v-btn>
        <v-btn
            :class="[currentSurveyMechanicReady ? 'primary' : 'secundary']"
            @click="mechanicReady"
        >Montage gereed
        </v-btn>
        <v-dialog v-model="reportDialog">
          <template v-slot:activator="{ on }">
            <v-btn class="report" color="secundary" v-on="on">Rapport</v-btn>
          </template>
          <v-card>
            <v-card-text>
              <report-view></report-view>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="reportDialog = false">sluiten</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-actions>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            :color="colorCameraButton"
            @click="openCamera"
            v-if="photoCount>0"
        >Camera ({{ photoCount }})
        </v-btn>
        <v-btn :color="colorCameraButton" @click="openCamera" v-else>Camera</v-btn>
        <v-btn @click="openHistory">geschiedenis</v-btn>
        <v-btn
            :class="[active.status !== 'DONE' ? 'secundary' : 'primary']"
            @click="downloadZip(active)"
            v-if="isAdmin"
        >Download
        </v-btn>
        <v-btn @click="$router.push(`/planner/list/${active.uniqueIdAssignment}`)">terug</v-btn>
      </v-card-actions>
    </v-card>
    <div v-if="showStatusForm">
      <change-status :initStatus="active.status" :statuses="allowedStatuses"></change-status>
    </div>
    <schedule-visit :visible="showScheduleVisitForm" showButtons="true"></schedule-visit>
    <phone-details :visible="showPhoneDetailsForm"></phone-details>
    <status-history :visible="showHistory"></status-history>
    <job-update :visible="showJobSelectionForm"></job-update>
    <planner-remark v-if="showPlannerRemark"></planner-remark>
  </v-flex>
</template>
<style scoped>
.report {
  margin-right: 6px;
}
</style>

<script>
import ChangeStatus from "@/components/address-details/ChangeStatus";
import DisplayPlannerRemark from "@/components/DisplayPlannerRemark";
import PhoneDetails from "@/components/address-details/PhoneDetails";
import PlannerRemark from "@/components/address-details/PlannerRemark"
import ReportView from "./ReportView";
import ScheduleVisit from "@/components/address-details/ScheduleVisit";
import StatusHistory from "@/components/address-details/StatusHistory";
import moment from "moment";
import {AREA_CODE_NL} from "@/components/address-details/PhoneDetails";
import {SURVEY_TYPE_MECHANIC, questionCookieService} from "@/services/question";
import {mapGetters, mapActions} from "vuex";
import {sharedStatusService} from "@/services/shared";
import {statusService} from "@/services/admin";
import JobUpdate from "@/components/address-details/JobUpdate";

export default {
  name: "address-details",
  components: {
    ChangeStatus,
    DisplayPlannerRemark,
    PhoneDetails,
    PlannerRemark,
    ReportView,
    ScheduleVisit,
    StatusHistory,
    JobUpdate,
  },
  data: () => ({
    showStatusForm: false,
    reportDialog: false,
    showPhoneDetailsForm: false,
    showScheduleVisitForm: false,
    showHistory: false,
    showJobSelectionForm: false,
    showPlannerRemark: false,
    allowedStatuses: []
  }),
  computed: {
    ...mapGetters({
      active: "activeAddress",
      photos: "photoUrls",
      isAdmin: "isAdmin",
      currentStatus: "currentStatus",
      currentSurveyPlannerReady: "currentSurveyPlannerReady",
      currentSurveyMechanicReady: "currentSurveyMechanicReady"
    }),
    photoCount() {
      return this.photos.length;
    },
    colorCameraButton() {
      if (this.isAdmin) {
        return "secundary";
      }
      return "primary";
    },
    showAdressDetails() {
      return !(
          this.showStatusForm ||
          this.showScheduleVisitForm ||
          this.showPhoneDetailsForm ||
          this.showHistory ||
          this.showJobSelectionForm ||
          this.showPlannerRemark
      );
    }
  },
  methods: {
    ...mapActions([
      "openCamera",
      "updateStatus",
      "updateStatusAdmin",
      "mechanicReady"
    ]),
    homeNumber(address) {
      if (address && address.address) {
        return address.address.homeNumber;
      }
      return undefined;
    },
    openStatusForm() {
      if (this.isAdmin) {
        statusService
            .allStatuses(this.active.uniqueIdAddress)
            .then(response => {
              this.allowedStatuses = response.data.map(e =>
                  sharedStatusService.resolveItem(e)
              );
              this.showStatusForm = true;
            });
      }
    },
    closeStatusForm() {
      this.showStatusForm = false;
    },
    openHistory() {
      this.showHistory = true;
    },
    closeHistory() {
      this.showHistory = false;
    },
    openUpdateJobForm() {
      this.showJobSelectionForm = true;
    },
    closeUpdateJobForm() {
      this.showJobSelectionForm = false;
    },
    openScheduleVisitForm() {
      this.showScheduleVisitForm = true;
    },
    closeScheduleVisitForm() {
      this.updateStatus();
      this.showScheduleVisitForm = false;
    },
    openPhoneDetailsForm() {
      this.showPhoneDetailsForm = true;
    },
    closePhoneDetailsForm() {
      this.showPhoneDetailsForm = false;
    },
    openPlannerRemark() {
      this.showPlannerRemark = true;
    },
    closePlannerRemark() {
      this.showPlannerRemark = false;
    },
    format(date) {
      if (date) {
        let curMoment = moment(date);
        curMoment.locale("nl");
        return curMoment.format("dddd D MMMM YYYY");
      }
      return "onbekend";
    },
    formatPhoneNumber(phone) {
      if (phone) {
        let part1 = "";
        let part2 = "";
        let part3 = "";
        let part4 = phone.substr(6, 2);
        let part5 = phone.substr(8, 2);
        if (phone.startsWith("06", 0)) {
          part1 = phone.substr(0, 2);
          part2 = phone.substr(2, 2);
          part3 = phone.substr(4, 2);
        } else if (phone.match(AREA_CODE_NL)) {
          part1 = phone.substr(0, 3);
          part2 = phone.substr(3, 3);
        } else {
          part1 = phone.substr(0, 4);
          part2 = phone.substr(4, 2);
        }
        return `(${part1}) ${part2} ${part3} ${part4} ${part5}`;
      } else {
        return "onbekend";
      }
    },
    downloadZip(item) {
      window.location.assign(
          "/api/v1/camera/" +
          item.uniqueIdAssignment +
          "/" +
          item.uniqueIdAddress +
          "?format=ZIP"
      );
      this.updateStatusAdmin("DONE");
    },
    openMechanicSurvey() {
      let payload = {
        "surveyType": SURVEY_TYPE_MECHANIC,
        "recordId": this.active.uniqueIdAddress
      };
      questionCookieService.resolveCookie(payload)
          // eslint-disable-next-line no-unused-vars
          .then(_ => {
            this.$router.push("/questions");
          });
    }
  }
};
</script>
